import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["noteField"]

  preserveData(event) {
    event.preventDefault()
    const noteValue = btoa(this.noteFieldTarget.value)
    const anchor = event.currentTarget
    const url = new URL(anchor.href)
    url.searchParams.set('note', noteValue)
    window.location.href = url.toString()
  }
}
